/* eslint-disable no-useless-escape */
import axios from 'axios'

import apiUrls from '@/constants/api'
import localeFormat from '@/constants/dateFormat'
import moment from 'moment'
import $ from 'jquery'

let withCredentials = { withCredentials: true }
if (process.env.VUE_APP_ENV === 'develop' || process.env.VUE_APP_ENV === 'local') {
  withCredentials = ''
}

const dateFormat = (date, locale) => {
  const formatDate = localeFormat.dateFormat(locale)
  const formatTime = localeFormat.timeFormat(locale)
  return moment(String(date)).format(formatDate + ' ' + formatTime)
}
const dataStateToQuery = (dataState, state) => {
  const query = []
  const exportQuery = []
  const defaultState = {
    action: {
      currentPage: 1
    },
    skip: 0,
    take: 12
  }
  const currentState = dataState || defaultState
  const { action, take, sorted, where } = currentState
  if (currentState) {
    const page = action ? (action.currentPage ? action.currentPage : 1) : 1
    const pageSize = take || 12
    query.push(`page=${page}`)
    query.push(`pagesize=${pageSize}`)
    if (sorted) {
      const sort = sorted[0]
      const column = sort.name !== 'childTemplates' ? sort.name : 'childs'
      // If statements to check if dataState sorted has already been set and avoid conditional statement to fail
      if (sort.direction === 'desc') {
        sort.direction = 'descending'
      }
      if (sort.direction === 'asc') {
        sort.direction = 'ascending'
      }
      const direction = sort.direction === 'descending' ? 'desc' : 'asc'
      query.push(`sortby=${direction}(${column.toLowerCase()})`)
      exportQuery.push(`sortby=${direction}(${column.toLowerCase()})`)
    }
    if (where) {
      const operations = {
        startswith: 'stw',
        endswith: 'edw',
        contains: 'cts',
        equals: 'eq',
        notequal: 'neq',
        greaterthan: 'gt',
        greaterthanorequal: 'gte',
        lessthan: 'lt',
        lessthanorequal: 'lte'
      }

      // .NET year format is yyyy instead of YYYY, and day format is dd instead of DD
      const dateFormat = state.dateFormat.replace(/Y/g, 'y').replace(/D/g, 'd')

      where[0].predicates.forEach(predicate => {
        const operator = operations[predicate.operator] || 'eq'
        if (predicate.field) {
          switch (predicate.field) {
            case 'tags':
              query.push(`tags.cts=${predicate.value}`)
              break
            case 'name':
              query.push(`name|editor.${operator}=${predicate.value}`)
              break
            case 'updateDate':
              query.push(`updatedate|updatedby[${dateFormat} ${state.timeFormat}].${operator}=${predicate.value}`)
              break
            case 'childTemplates':
              query.push(`childs.${operator}=${predicate.value}`)
              break
            default:
              query.push(`${predicate.field.toLowerCase()}.${operator}=${predicate.value}`)
          }
        } else if (predicate.predicates) { // Tags
          const tags = predicate.predicates.map(pred => pred.value).join(',')
          query.push(`tags.cts=${tags}`)
        }
      })
    }
  } else {
    query.push('page=1')
    query.push('pagesize=12')
  }
  if (state.isSearchingTemplate && !query.find((x) => x.indexOf('active.') > -1)) {
    query.push('active.eq=true')
  }
  const dynamicQuery = query.length === 0 ? '' : 'dynamicquery=' + encodeURIComponent(query.join('&'))
  return dynamicQuery
}

const getPathWithDynamicQuery = (state, userEmail, dataState, editorFilter) => {
  const dynamicQuery = dataStateToQuery(dataState, state)
  const editorTypeQuery = editorFilter
  return state.paging.searchBox.length
    ? apiUrls.template.getTemplatesSearch(state.accountId, userEmail, editorTypeQuery, encodeURI(state.paging.searchBox), dynamicQuery)
    : apiUrls.template.getTemplates(state.accountId, userEmail, editorTypeQuery, dynamicQuery)
}

const getPathWithDynamicPrebuilt = (state, userEmail, dataState, editorFilter) => {
  const dynamicQuery = dataStateToQuery(dataState, state)
  const editorTypeQuery = editorFilter
  return state.globalPaging.searchBox.length
    ? apiUrls.template.globalTemplateSearch(state.accountId, userEmail, editorTypeQuery, encodeURI(state.globalPaging.searchBox), dynamicQuery)
    : apiUrls.template.globalTemplates(state.accountId, userEmail, editorTypeQuery, dynamicQuery)
}

const isHtmlElement = (htmlString) => {
  console.log('isHtmlElement init: ', htmlString)
  const el = createElementFromHTML(htmlString)
  console.log('el: ', el)
  try {
    return el instanceof HTMLElement
  } catch (e) {
    // Browsers not supporting W3 DOM2 don't have HTMLElement and
    // an exception is thrown and we end up here. Testing some
    // properties that all elements have (works on IE7)
    return (typeof el === 'object') &&
      (el.nodeType === 1) &&
      (typeof el.style === 'object') &&
      (typeof el.ownerDocument === 'object')
  }
}

const createElementFromHTML = (htmlString) => {
  const div = document.createElement('div')
  div.innerHTML = htmlString.trim()
  return div.firstChild
}

export const actions = {
  setActiveView ({ commit }, name) {
    commit('SET_SELECTED_TEMPLATE', null)
    commit('SET_ACTIVE_VIEW', name)
  },
  setActiveType ({ commit }, name) {
    commit('SET_SELECTED_TEMPLATE', null)
    commit('SET_ACTIVE_TYPE', name)
  },
  setTemplates ({ commit, state, getters }, { userEmail, dataState }) {
    const loading = {
      name: 'templates',
      status: true
    }
    if (!getters.getLoadingStatusItem(loading.name)) {
      commit('SET_LOADING', loading)

      if (state.accountId > 0) {
        const editorFilterArray = getters.getSavedGridEditorFilter
        let editorFilter = '?'
        if (editorFilterArray.includes('Studio Editor')) {
          editorFilter = editorFilter + 'editorTypeIDs=1'
        }
        if (editorFilterArray.includes('Classic Drag & Drop')) {
          editorFilter = editorFilter + '&editorTypeIDs=2'
        }
        if (editorFilterArray.includes('Custom Code')) {
          editorFilter = editorFilter + '&editorTypeIDs=3'
        }

        const path = getPathWithDynamicQuery(state, userEmail, dataState, editorFilter)
        return new Promise((resolve, reject) => {
          axios.get(path, withCredentials)
            .then(response => {
              const { data, page } = response.data
              if (data) {
                const result = data.map(element => {
                  const editor = state.editorsTypes.find(e => e.id === element.template.editorTypeId)?.description
                  return {
                    ...element.template,
                    editor,
                    status: (element.template.active ? 'Active' : 'Inactive'),
                    childTemplates: element.childTemplates,
                    tags: element.tags.map(t => t.name).join(', '),
                    base64Thumbnail: element.base64Thumbnail
                  }
                })
                const dataResult = {
                  result,
                  count: page.totalRecords
                }
                commit('SET_TEMPLATES', dataResult)
              } else {
                const dataResult = {
                  result: [],
                  count: 0
                }
                commit('SET_TEMPLATES', dataResult)
              }
              if (page) {
                const paging = {
                  totalRecords: page.totalRecords ?? 12
                }
                commit('SET_PAGING', paging)
              }
              resolve({
                success: true
              })
              loading.status = false
              commit('SET_LOADING', loading)
            })
            .catch(error => {
              console.log(error)
              reject(error)
              loading.status = false
              commit('SET_LOADING', loading)
            })
        })
      }
    }
  },
  setGlobalTemplates ({ commit, state, getters }, { userEmail, dataState }) {
    const loading = {
      name: 'templates',
      status: true
    }
    if (!getters.getLoadingStatusItem(loading.name)) {
      commit('SET_LOADING', loading)

      if (state.accountId > 0) {
        const editorFilterArray = getters.getPrebuiltGridEditorFilter
        let editorFilter = '?'
        if (editorFilterArray.includes('Studio Editor')) {
          editorFilter = editorFilter + 'editorTypeIDs=1'
        }
        if (editorFilterArray.includes('Classic Drag & Drop')) {
          editorFilter = editorFilter + '&editorTypeIDs=2'
        }
        if (editorFilterArray.includes('Custom Code')) {
          editorFilter = editorFilter + '&editorTypeIDs=3'
        }
        const path = getPathWithDynamicPrebuilt(state, userEmail, dataState, editorFilter)

        return new Promise((resolve, reject) => {
          axios.get(path, withCredentials)
            .then(response => {
              const { data, page } = response.data
              if (data) {
                const result = data.map(element => {
                  // const editor = state.editorsTypes.find(e => e.id === element.template.editorTypeId)?.description
                  return {
                    ...element.template,
                    // editor,
                    childTemplates: element.childTemplates,
                    tags: element.tags.map(t => t.name).join(', '),
                    base64Thumbnail: element.base64Thumbnail
                  }
                })
                const dataResult = {
                  result,
                  count: page.totalRecords
                }
                commit('SET_GLOBAL_TEMPLATES', dataResult)
              } else {
                const dataResult = {
                  result: [],
                  count: 0
                }
                commit('SET_GLOBAL_TEMPLATES', dataResult)
              }
              if (page) {
                const paging = {
                  totalRecords: page.totalRecords ?? 12
                }
                commit('SET_GLOBAL_PAGING', paging)
              }
              resolve({
                success: true
              })
              loading.status = false
              commit('SET_LOADING', loading)
            })
            .catch(error => {
              console.log(error)
              reject(error)
              loading.status = false
              commit('SET_LOADING', loading)
            })
        })
      }
    }
  },
  setCompanyGlobalPermission ({ commit, state }, { externalId, userEmail, showLoading = true }) {
    const loading = {
      name: 'set_global_permission',
      status: true
    }
    if (showLoading) {
      commit('SET_LOADING', loading)
    }
    return new Promise((resolve, reject) => {
      const path = apiUrls.template.companyGlobalTemplate(externalId, userEmail)
      axios.get(path, withCredentials)
        .then(response => {
          resolve(response.data)
          if (response.data.data != null) {
            const permissionResponse = Boolean(Number(response.data.data.settingValue))
            commit('SET_GLOBAL_COMPANY_PERMISSION', permissionResponse)
          }
          if (showLoading) {
            loading.status = false
            commit('SET_LOADING', loading)
          }
        })
        .catch(error => {
          console.log(error)
          if (showLoading) {
            loading.status = false
            commit('SET_LOADING', loading)
          }
          reject(error)
        })
    })
  },
  setUserGlobalPermission ({ commit, state }, { userEmail, showLoading = true }) {
    const loading = {
      name: 'set_user_permission',
      status: true
    }
    if (showLoading) {
      commit('SET_LOADING', loading)
    }
    return new Promise((resolve, reject) => {
      const path = apiUrls.template.userGlobalTemplate(userEmail)
      axios.get(path, withCredentials)
        .then(response => {
          resolve(response.data)
          const permissionResponse = Boolean(Number(response.data.data.SaveAsGlobalTemplate))
          commit('SET_USER_COMPANY_PERMISSION', permissionResponse)
          if (showLoading) {
            loading.status = false
            commit('SET_LOADING', loading)
          }
        })
        .catch(error => {
          console.log(error)
          if (showLoading) {
            loading.status = false
            commit('SET_LOADING', loading)
          }
          reject(error)
        })
    })
  },
  setTemplateSummary ({ commit, state }, { templateId, userEmail, showLoading = true }) {
    const loading = {
      name: 'set_template_summary',
      status: true
    }
    if (showLoading) {
      commit('SET_LOADING', loading)
    }
    return new Promise((resolve, reject) => {
      const path = apiUrls.template.getTemplate(state.accountId, userEmail, templateId)
      axios.get(path, withCredentials)
        .then(response => {
          commit('SET_TEMPLATE_SUMMARY', response.data)
          resolve(response.data)
          if (showLoading) {
            loading.status = false
            commit('SET_LOADING', loading)
          }
        })
        .catch(error => {
          console.log(error)
          if (showLoading) {
            loading.status = false
            commit('SET_LOADING', loading)
          }
          reject(error)
        })
    })
  },
  setPrebuiltTemplateSummary ({ commit, state }, { templateId, userEmail, showLoading = true }) {
    const loading = {
      name: 'set_template_summary',
      status: true
    }
    if (showLoading) {
      commit('SET_LOADING', loading)
    }
    return new Promise((resolve, reject) => {
      const path = apiUrls.template.getPrebuiltTemplate(state.accountId, userEmail, templateId)
      axios.get(path, withCredentials)
        .then(response => {
          commit('SET_TEMPLATE_SUMMARY', response.data)
          resolve(response.data)
          if (showLoading) {
            loading.status = false
            commit('SET_LOADING', loading)
          }
        })
        .catch(error => {
          console.log(error)
          if (showLoading) {
            loading.status = false
            commit('SET_LOADING', loading)
          }
          reject(error)
        })
    })
  },
  setTemplateHistory ({ commit, state }, { templateId, userEmail, showLoading = true }) {
    const loading = {
      name: 'set_template_history',
      status: true
    }
    if (showLoading) {
      commit('SET_LOADING', loading)
    }
    const path = apiUrls.template.getTemplateHistory(state.accountId, templateId, userEmail)
    axios.get(path, withCredentials)
      .then(response => {
        const history = response.data.map(item => ({
          ...item,
          hasBeenOpened: false,
          opened: false
        }))
        commit('SET_TEMPLATE_HISTORY', history)
        if (showLoading) {
          loading.status = false
          commit('SET_LOADING', loading)
        }
      })
      .catch(error => {
        console.log(error)
        if (showLoading) {
          loading.status = false
          commit('SET_LOADING', loading)
        }
      })
  },
  setPrebuiltTemplateHistory ({ commit, state }, { templateId, userEmail, showLoading = true }) {
    const loading = {
      name: 'set_prebuilt_template_history',
      status: true
    }
    if (showLoading) {
      commit('SET_LOADING', loading)
    }
    const path = apiUrls.template.getPrebuiltTemplateHistory(state.accountId, templateId, userEmail)
    axios.get(path, withCredentials)
      .then(response => {
        const history = response.data.map(item => ({
          ...item,
          hasBeenOpened: false,
          opened: false
        }))
        commit('SET_TEMPLATE_HISTORY', history)
        if (showLoading) {
          loading.status = false
          commit('SET_LOADING', loading)
        }
      })
      .catch(error => {
        console.log(error)
        if (showLoading) {
          loading.status = false
          commit('SET_LOADING', loading)
        }
      })
  },
  setTemplateCampaigns ({ commit, state }, { clientId, companyId, isPrimary, userEmail, showLoading = true }) {
    const loading = {
      name: 'set_template_campaigns',
      status: true
    }
    if (showLoading) {
      commit('SET_LOADING', loading)
    }
    axios.get(apiUrls.template.getTemplateCampaigns(clientId, companyId, isPrimary, userEmail), withCredentials)
      .then(response => {
        const childMap = state.template.summary.childMap
        const campaigns = Object.keys(childMap).map((e) => childMap[e].map(child => child.item2)).flat()
        const data = response.data.filter(e => campaigns.includes(e.projectId.toString()))
        data.forEach(campaign => {
          if (campaign.updateDate !== 'Invalid date' && campaign.updateDate) {
            campaign.updateDate = dateFormat(campaign.updateDate, state.locale)
          }
        })
        commit('SET_TEMPLATE_CAMPAIGNS', data)
        if (showLoading) {
          loading.status = false
          commit('SET_LOADING', loading)
        }
      })
      .catch(error => {
        console.log(error)
        if (showLoading) {
          loading.status = false
          commit('SET_LOADING', loading)
        }
      })
  },
  revertTemplateVersion ({ commit, state }, { userEmail, templateId, templateVersionId }) {
    const loading = {
      name: 'revert_template_version',
      status: true
    }
    return new Promise((resolve, reject) => {
      commit('SET_LOADING', loading)
      axios.post(apiUrls.template.revertTemplateVersion(state.accountId, templateId, templateVersionId, userEmail), withCredentials)
        .then(response => {
          const { data } = response
          if (data.success) {
            commit('SET_TEMPLATE_HISTORY_ITEM_REVERSION', templateVersionId)
            resolve(data.success)
          } else {
            resolve(null)
          }
          loading.status = false
          commit('SET_LOADING', loading)
        })
        .catch(error => {
          reject(error)
          loading.status = false
          commit('SET_LOADING', loading)
        })
    })
  },
  revertPrebuiltTemplateVersion ({ commit, state }, { userEmail, templateId, templateVersionId }) {
    const loading = {
      name: 'revert_template_version',
      status: true
    }
    return new Promise((resolve, reject) => {
      commit('SET_LOADING', loading)
      axios.post(apiUrls.template.revertPrebuiltTemplateVersion(state.accountId, templateId, templateVersionId, userEmail), withCredentials)
        .then(response => {
          const { data } = response
          if (data.success) {
            commit('SET_TEMPLATE_HISTORY_ITEM_REVERSION', templateVersionId)
            resolve(data.success)
          } else {
            resolve(null)
          }
          loading.status = false
          commit('SET_LOADING', loading)
        })
        .catch(error => {
          reject(error)
          loading.status = false
          commit('SET_LOADING', loading)
        })
    })
  },
  setTemplatePreviewContent ({ commit, state }, { userEmail, templateId, templateVersionId, templateHistoryId }) {
    const loading = {
      name: 'set_template_preview',
      status: true
    }
    commit('SET_LOADING', loading)
    return new Promise((resolve, reject) => {
      axios.get(apiUrls.template.getTemplatePreview(state.accountId, userEmail, templateId, templateVersionId), withCredentials)
        .then(response => {
          const { data } = response
          if (data.html) {
            commit('SET_TEMPLATE_PREVIEW_CONTENT', data.html)
            if (templateHistoryId) {
              commit('SET_TEMPLATE_HISTORY_ITEM_PREVIEW_CONTENT', { templateId, previewContent: data.html })
            }
            resolve(data.html)
          } else {
            resolve(null)
          }
          loading.status = false
          commit('SET_LOADING', loading)
        })
        .catch(error => {
          console.log(error)
          reject(error)
          loading.status = false
          commit('SET_LOADING', loading)
        })
    })
  },
  setPrebuiltTemplatePreviewContent ({ commit, state }, { userEmail, templateId, templateVersionId, templateHistoryId }) {
    const loading = {
      name: 'set_template_preview',
      status: true
    }
    commit('SET_LOADING', loading)
    return new Promise((resolve, reject) => {
      axios.get(apiUrls.template.getPrebuiltTemplatePreview(state.accountId, userEmail, templateId, templateVersionId), withCredentials)
        .then(response => {
          const { data } = response
          if (data.html) {
            commit('SET_TEMPLATE_PREVIEW_CONTENT', data.html)
            if (templateHistoryId) {
              commit('SET_TEMPLATE_HISTORY_ITEM_PREVIEW_CONTENT', { templateId, previewContent: data.html })
            }
            resolve(data.html)
          } else {
            resolve(null)
          }
          loading.status = false
          commit('SET_LOADING', loading)
        })
        .catch(error => {
          console.log(error)
          reject(error)
          loading.status = false
          commit('SET_LOADING', loading)
        })
    })
  },
  setLocale ({ commit }, { userEmail }) {
    axios.get(apiUrls.user.getLocale(userEmail), withCredentials)
      .then(response => {
        const locale = response.data.data ?? 'en-US'
        commit('SET_LOCALE', locale)
        commit('SET_DATE_FORMAT', localeFormat.dateFormat(locale))
        commit('SET_TIME_FORMAT', localeFormat.timeFormat(locale))
      })
      .catch(error => {
        console.log(error)
      })
  },
  setAccountId ({ commit, getters }, { externalId, userEmail }) {
    const loading = {
      name: 'account_by_external_id',
      status: true
    }
    if (!getters.getLoadingStatusItem(loading.name)) {
      commit('SET_LOADING', loading)
      axios.get(apiUrls.account.getAccountIdbyExternalId(externalId, userEmail), withCredentials)
        .then(response => {
          commit('SET_ACCOUNT', response.data)
          commit('SET_ACCOUNTID', response.data.id)
          loading.status = false
          commit('SET_LOADING', loading)
        })
        .catch(error => {
          console.log(error)
          loading.status = false
          commit('SET_LOADING', loading)
        })
    }
  },
  setParentCompanySetting ({ commit, state, getters }, { settings, email }) {
    const loading = {
      name: 'parent_company_settings',
      status: true
    }
    if (!getters.getLoadingStatusItem(loading.name)) {
      commit('SET_LOADING', loading)
      axios.get(apiUrls.user.getParentCompanySettings(state.accountId, settings, email), withCredentials)
        .then(response => {
          commit('SET_TEMPLATE_JOURNEY', response.data.data)
          loading.status = false
          commit('SET_LOADING', loading)
        })
        .catch(error => {
          console.log(error)
          loading.status = false
          commit('SET_LOADING', loading)
        })
    }
  },
  setCompanySetting ({ commit, state, getters }, { settings, email }) {
    const loading = {
      name: 'company_settings',
      status: true
    }
    if (!getters.getLoadingStatusItem(loading.name)) {
      commit('SET_LOADING', loading)
      axios.get(apiUrls.user.getCompanySettings(state.accountId, settings, email), withCredentials)
        .then(response => {
          if (settings === 'TransactionalMailingInTestMode') {
            commit('SET_TRANSACTIONAL_TEST_MODE', response.data.data)
          } else if (settings === 'HasEmailContentApproval') {
            commit('SET_HAS_EMAIL_CONTENT_APPROVAL', response.data.data)
          }
          loading.status = false
          commit('SET_LOADING', loading)
        })
        .catch(error => {
          console.log(error)
          loading.status = false
          commit('SET_LOADING', loading)
        })
    }
  },
  setUserAccessControl ({ commit }, { userEmail }) {
    axios.get(apiUrls.user.getUserAccessControl(userEmail), withCredentials)
      .then(response => {
        commit('SET_USER_ACCESS_CONTROL', response.data.data)
      })
      .catch(error => {
        console.log(error)
      })
  },
  setTemplateBasicValidation ({ commit, state, getters }, { templateId }) {
    const loading = {
      name: 'template_basic_validation',
      status: true
    }
    if (!getters.getLoadingStatusItem(loading.name)) {
      commit('SET_LOADING', loading)
      const path = apiUrls.template.getBasicValidation(state.accountId, templateId, state.userEmail)
      axios.get(path, withCredentials)
        .then(response => {
          const data = response.data
          commit('SET_BASIC_VALIDATION', data)
          commit('SET_VALIDATION_TEMPLATE_ID', templateId)
          loading.status = false
          commit('SET_LOADING', loading)
        })
        .catch(error => {
          console.log(error)
          loading.status = false
          commit('SET_LOADING', loading)
        })
    }
  },
  setPrebuiltTemplateBasicValidation ({ commit, state, getters }, { templateId }) {
    const loading = {
      name: 'template_basic_validation',
      status: true
    }
    if (!getters.getLoadingStatusItem(loading.name)) {
      commit('SET_LOADING', loading)
      const path = apiUrls.template.validatePrebuiltTemplate(state.accountId, templateId, state.userEmail)
      axios.get(path, withCredentials)
        .then(response => {
          const data = response.data
          commit('SET_BASIC_VALIDATION', data)
          commit('SET_VALIDATION_TEMPLATE_ID', templateId)
          loading.status = false
          commit('SET_LOADING', loading)
        })
        .catch(error => {
          console.log(error)
          loading.status = false
          commit('SET_LOADING', loading)
        })
    }
  },
  setProperties ({ state, commit, getters }, { clientId, userEmail }) {
    if (state.allowedAccounts.length) {
      return new Promise((resolve) => {
        resolve({
          success: {
            allowedAccounts: state.allowedAccounts
          }
        })
      })
    } else {
      const loading = {
        name: 'get_properties',
        status: true
      }
      return new Promise((resolve, reject) => {
        if (!getters.getLoadingStatusItem(loading.name)) {
          commit('SET_LOADING', loading)
          axios.get(apiUrls.legacy.getProperties(clientId, userEmail), withCredentials)
            .then(({ status, statusText, data }) => {
              if (status === 200 && data.message && data.message.toLowerCase() === 'success') {
                commit('SET_ALLOWED_ACCOUNTS', data.data)
                resolve({
                  success: {
                    allowedAccounts: data.data
                  }
                })
              } else {
                resolve({
                  error: {
                    status,
                    statusText
                  }
                })
              }
              loading.status = false
              commit('SET_LOADING', loading)
            })
            .catch(error => {
              loading.status = false
              commit('SET_LOADING', loading)
              reject(error)
            })
        } else {
          resolve({
            concurrence: true
          })
          loading.status = false
          commit('SET_LOADING', loading)
        }
      })
    }
  },
  getPopularTags ({ commit, getters }, { userEmail }) {
    const loading = {
      name: 'popular_tags',
      status: true
    }
    return new Promise((resolve, reject) => {
      if (!getters.getLoadingStatusItem(loading.name)) {
        commit('SET_LOADING', loading)
        axios.get(apiUrls.template.getPopularTags(userEmail), withCredentials)
          .then(({ status, statusText, data }) => {
            if (status === 200) {
              resolve({
                success: {
                  tags: data
                }
              })
            } else {
              resolve({
                error: {
                  status,
                  statusText
                }
              })
            }
            loading.status = false
            commit('SET_LOADING', loading)
          })
          .catch(error => {
            loading.status = false
            commit('SET_LOADING', loading)
            reject(error)
          })
      } else {
        resolve({
          concurrence: true
        })
        loading.status = false
        commit('SET_LOADING', loading)
      }
    })
  },
  getBeeFreeClient ({ commit, state, getters }, { userEmail }) {
    const loading = {
      name: 'get_bee_free_client',
      status: true
    }
    return new Promise((resolve, reject) => {
      if (!getters.getLoadingStatusItem(loading.name)) {
        commit('SET_LOADING', loading)
        axios.get(apiUrls.template.getDragDropClient(userEmail), withCredentials)
          .then(({ status, statusText, data }) => {
            if (status === 200) {
              resolve({
                success: {
                  tokenData: data
                }
              })
            } else {
              resolve({
                error: {
                  status,
                  statusText
                }
              })
            }
            loading.status = false
            commit('SET_LOADING', loading)
          })
          .catch(error => {
            loading.status = false
            commit('SET_LOADING', loading)
            reject(error)
          })
      } else {
        resolve({
          concurrence: true
        })
        loading.status = false
        commit('SET_LOADING', loading)
      }
    })
  },
  getEgalleryLink ({ commit, state, getters }, { externalId, userEmail }) {
    const loading = {
      name: 'get_eGallery_link',
      status: true
    }
    const eInsightURL = state.einsightUri
    return new Promise((resolve, reject) => {
      if (!getters.getLoadingStatusItem(loading.name)) {
        commit('SET_LOADING', loading)
        axios.get(apiUrls.legacy.getEgalleryButtonLink(eInsightURL, externalId, userEmail), withCredentials)
          .then(({ status, statusText, data }) => {
            if (status === 200) {
              resolve({
                success: {
                  data: data
                }
              })
            } else {
              resolve({
                error: {
                  status,
                  statusText
                }
              })
            }
            loading.status = false
            commit('SET_LOADING', loading)
          })
          .catch(error => {
            loading.status = false
            commit('SET_LOADING', loading)
            reject(error)
          })
      } else {
        resolve({
          concurrence: true
        })
        loading.status = false
        commit('SET_LOADING', loading)
      }
    })
  },
  getBeeFreeMergeTags ({ commit, state, getters }, { userEmail }) {
    const loading = {
      name: 'get_template_merge_tags',
      status: true
    }
    return new Promise((resolve, reject) => {
      if (!getters.getLoadingStatusItem(loading.name)) {
        commit('SET_LOADING', loading)
        axios.get(apiUrls.template.getBeeFreeEditorMergeTags(1, userEmail), withCredentials)
          .then(({ status, statusText, data }) => {
            if (status === 200) {
              resolve({
                success: {
                  data: data
                }
              })
            } else {
              resolve({
                error: {
                  status,
                  statusText
                }
              })
            }
            loading.status = false
            commit('SET_LOADING', loading)
          })
          .catch(error => {
            loading.status = false
            commit('SET_LOADING', loading)
            reject(error)
          })
      } else {
        resolve({
          concurrence: true
        })
        loading.status = false
        commit('SET_LOADING', loading)
      }
    })
  },
  getBeeFreeToken ({ commit, state, getters }) {
    const loading = {
      name: 'create_template',
      status: true
    }
    return new Promise((resolve, reject) => {
      if (!getters.getLoadingStatusItem(loading.name)) {
        commit('SET_LOADING', loading)
        axios.post('https://auth.getbee.io/apiauth', {
          client_id: '5a7a720d-7048-40d8-863d-a2441916e6cb',
          client_secret: 'HA8fabuyRVLmmp5jgZrRHkERlO9skPl1bSdeUy06HvU4IfUlKaU',
          grant_type: 'password'
        })
          .then(({ data }) => {
            commit('SET_LOADING', false)

            loading.status = false
            commit('SET_LOADING', loading)
            console.log('[be free token stuff]: ', data)
          })
          .catch(error => {
            reject(error)
            loading.status = false
            commit('SET_LOADING', loading)
          })
      }
    })
  },
  setAccounts ({ state, commit, getters }, { userEmail }) {
    if (state.allAccounts.length) {
      return new Promise((resolve) => {
        resolve({
          success: {
            accounts: state.allAccounts
          }
        })
      })
    } else {
      const loading = {
        name: 'get_accounts',
        status: true
      }
      return new Promise((resolve, reject) => {
        if (!getters.getLoadingStatusItem(loading.name)) {
          commit('SET_LOADING', loading)
          axios.get(apiUrls.account.getAccounts(userEmail), withCredentials)
            .then(({ status, statusText, data }) => {
              if (status === 200) {
                commit('SET_ALL_ACCOUNTS', data)
                resolve({
                  success: {
                    accounts: data
                  }
                })
              } else {
                resolve({
                  error: {
                    status,
                    statusText
                  }
                })
              }
              loading.status = false
              commit('SET_LOADING', loading)
            })
            .catch(error => {
              loading.status = false
              commit('SET_LOADING', loading)
              reject(error)
            })
        } else {
          resolve({
            concurrence: true
          })
          loading.status = false
          commit('SET_LOADING', loading)
        }
      })
    }
  },
  getAvailableProperties ({ dispatch, state, commit, getters }, params) {
    if (state.availableAccounts.length) {
      return new Promise((resolve) => {
        resolve(state.availableAccounts)
      })
    } else {
      const propertiesPromise = dispatch('setProperties', params)
      const accountsPromise = dispatch('setAccounts', params)
      const loading = {
        name: 'get_available_properties',
        status: true
      }
      return new Promise((resolve, reject) => {
        if (getters.getLoadingStatusItem(loading.name)) return
        Promise.all([propertiesPromise, accountsPromise]).then((response) => {
          commit('SET_LOADING', loading)
          const [propertiesResponse, accountsResponse] = response
          if (propertiesResponse.success) {
            const allowedAccounts = propertiesResponse.success.allowedAccounts
            if (accountsResponse.success) {
              const semiFinalAccounts = {}
              const allAccounts = accountsResponse.success.accounts
              for (const i in allowedAccounts) {
                semiFinalAccounts[parseInt(allowedAccounts[i].id)] = {
                  id: 0,
                  name: allowedAccounts[i].name
                }
              }
              for (const i in allAccounts) {
                if (allAccounts[i].externalId in semiFinalAccounts && semiFinalAccounts[allAccounts[i].externalId].id === 0) {
                  semiFinalAccounts[allAccounts[i].externalId].id = allAccounts[i].id
                }
              }
              let finalAccounts = []
              for (const key in semiFinalAccounts) {
                finalAccounts.push({
                  ...semiFinalAccounts[key],
                  externalId: key
                })
              }
              finalAccounts = finalAccounts.filter(a => a.id > 0)
              commit('SET_AVAILABLE_ACCOUNTS', finalAccounts)
              resolve({
                success: {
                  availableAccounts: finalAccounts
                }
              })
            }
          }
          loading.status = false
          commit('SET_LOADING', loading)
        }).catch(err => {
          console.error(err)
          loading.status = false
          commit('SET_LOADING', loading)
          reject(err)
        })
      })
    }
  },
  createTemplate ({ commit, state, getters }, { userEmail, data }) {
    const loading = {
      name: 'create_template',
      status: true
    }
    return new Promise((resolve, reject) => {
      if (!getters.getLoadingStatusItem(loading.name)) {
        commit('SET_LOADING', loading)
        axios.post(apiUrls.template.createTemplate(state.accountId, userEmail), data, withCredentials)
          .then(({ status, statusText, data }) => {
            commit('SET_LOADING', false)
            if (status === 200) {
              resolve({
                success: data
              })
            } else {
              resolve({
                error: {
                  status,
                  statusText
                }
              })
            }
            loading.status = false
            commit('SET_LOADING', loading)
          })
          .catch(error => {
            reject(error)
            loading.status = false
            commit('SET_LOADING', loading)
          })
      }
    })
  },
  setTemplateOnEdition ({ commit, state, getters }, { userEmail, templateId }) {
    const loading = {
      name: 'set_template_on_edition',
      status: true
    }
    if (!getters.getLoadingStatusItem(loading.name)) {
      commit('SET_LOADING', loading)
      axios.get(apiUrls.template.getTemplate(state.accountId, userEmail, templateId), withCredentials)
        .then(({ status, statusText, data }) => {
          if (status === 200) {
            commit('SET_TEMPLATE_ON_EDITION', data)
          }
          loading.status = false
          commit('SET_LOADING', loading)
        })
        .catch(error => {
          console.log(error)
          loading.status = false
          commit('SET_LOADING', loading)
        })
    }
  },
  setPrebuiltTemplateOnEdition ({ commit, state, getters }, { userEmail, templateId }) {
    const loading = {
      name: 'set_template_on_edition',
      status: true
    }
    if (!getters.getLoadingStatusItem(loading.name)) {
      commit('SET_LOADING', loading)
      axios.get(apiUrls.template.getPrebuiltTemplate(state.accountId, userEmail, templateId), withCredentials)
        .then(({ status, statusText, data }) => {
          if (status === 200) {
            commit('SET_TEMPLATE_ON_EDITION', data)
          }
          loading.status = false
          commit('SET_LOADING', loading)
        })
        .catch(error => {
          console.log(error)
          loading.status = false
          commit('SET_LOADING', loading)
        })
    }
  },
  getPrebuiltTemplate ({ commit, state, getters }, { userEmail, templateId }) {
    const loading = {
      name: 'get_template',
      status: true
    }
    return new Promise((resolve, reject) => {
      if (!getters.getLoadingStatusItem(loading.name)) {
        commit('SET_LOADING', loading)
        axios.get(apiUrls.template.getPrebuiltTemplate(state.accountId, userEmail, templateId), withCredentials)
          .then(({ data }) => {
            resolve(data)
            loading.status = false
            commit('SET_LOADING', loading)
          })
          .catch(error => {
            reject(error)
            console.log(error)
            loading.status = false
            commit('SET_LOADING', loading)
          })
      }
    })
  },
  updateTemplateOnEdition ({ commit, state, getters }, { userEmail, data }) {
    const loading = {
      name: 'update_template_on_edition',
      status: true
    }
    return new Promise((resolve, reject) => {
      if (!getters.getLoadingStatusItem(loading.name)) {
        commit('SET_LOADING', loading)
        axios.post(apiUrls.template.updateTemplate(state.accountId, userEmail), data, withCredentials)
          .then(({ status, statusText, data }) => {
            if (status === 200) {
              resolve({
                success: data
              })
            } else {
              resolve({
                error: {
                  status,
                  statusText
                }
              })
            }
            loading.status = false
            commit('SET_LOADING', loading)
          })
          .catch(error => {
            reject(error)
            loading.status = false
            commit('SET_LOADING', loading)
          })
      }
    })
  },
  updatePrebuiltTemplateOnEdition ({ commit, state, getters }, { userEmail, data }) {
    const loading = {
      name: 'update_template_on_edition',
      status: true
    }
    return new Promise((resolve, reject) => {
      if (!getters.getLoadingStatusItem(loading.name)) {
        commit('SET_LOADING', loading)
        axios.post(apiUrls.template.updatePrebuiltTemplate(state.accountId, userEmail), data, withCredentials)
          .then(({ status, statusText, data }) => {
            if (status === 200) {
              resolve({
                success: data
              })
            } else {
              resolve({
                error: {
                  status,
                  statusText
                }
              })
            }
            loading.status = false
            commit('SET_LOADING', loading)
          })
          .catch(error => {
            reject(error)
            loading.status = false
            commit('SET_LOADING', loading)
          })
      }
    })
  },
  deleteTemplate ({ commit, state, getters }, { userEmail, templateId }) {
    const loading = {
      name: 'delete_template',
      status: true
    }
    return new Promise((resolve, reject) => {
      if (!getters.getLoadingStatusItem(loading.name)) {
        commit('SET_LOADING', loading)
        axios.post(apiUrls.template.deleteTemplate(state.accountId, userEmail, templateId), withCredentials)
          .then(({ status, statusText, data }) => {
            commit('SET_LOADING', false)
            if (status === 200) {
              resolve({
                success: data
              })
            } else {
              resolve({
                error: {
                  status,
                  statusText
                }
              })
            }
            loading.status = false
            commit('SET_LOADING', loading)
          })
          .catch(error => {
            console.log(error)
            reject(error)
          })
      }
    })
  },
  deletePrebuiltTemplate ({ commit, state, getters }, { userEmail, templateId }) {
    const loading = {
      name: 'delete_template',
      status: true
    }
    return new Promise((resolve, reject) => {
      if (!getters.getLoadingStatusItem(loading.name)) {
        commit('SET_LOADING', loading)
        axios.post(apiUrls.template.deletePrebuiltTemplate(state.accountId, userEmail, templateId), withCredentials)
          .then(({ status, statusText, data }) => {
            commit('SET_LOADING', false)
            if (status === 200) {
              resolve({
                success: data
              })
            } else {
              resolve({
                error: {
                  status,
                  statusText
                }
              })
            }
            loading.status = false
            commit('SET_LOADING', loading)
          })
          .catch(error => {
            console.log(error)
            reject(error)
          })
      }
    })
  },
  cloneTemplate ({ commit, state, getters }, { userEmail, templateId }) {
    const loading = {
      name: 'clone_template',
      status: true
    }
    return new Promise((resolve, reject) => {
      if (!getters.getLoadingStatusItem(loading.name)) {
        commit('SET_LOADING', loading)
        axios.post(apiUrls.template.cloneTemplate(state.accountId, userEmail, templateId), withCredentials)
          .then(({ status, statusText, data }) => {
            if (status === 200) {
              console.log(data)
              this.dispatch('activeTemplate', { templateId: data.templateId, userEmail, active: true })
                .then(() => {
                  resolve({
                    success: data
                  })
                })
            } else {
              resolve({
                error: {
                  status,
                  statusText
                }
              })
            }
            loading.status = false
            commit('SET_LOADING', loading)
          })
          .catch(error => {
            console.log(error)
            reject(error)
            loading.status = false
            commit('SET_LOADING', loading)
          })
      }
    })
  },
  prebuiltCloneTemplate ({ commit, state, getters }, { userEmail, templateId }) {
    const loading = {
      name: 'prebuiltCloneTemplate',
      status: true
    }
    return new Promise((resolve, reject) => {
      if (!getters.getLoadingStatusItem(loading.name)) {
        commit('SET_LOADING', loading)
        axios.post(apiUrls.template.prebuiltCloneTemplate(state.accountId, userEmail, templateId), withCredentials)
          .then(({ status, statusText, data }) => {
            if (status === 200) {
              console.log(data)
              resolve({
                success: data
              })
            } else {
              resolve({
                error: {
                  status,
                  statusText
                }
              })
            }
            loading.status = false
            commit('SET_LOADING', loading)
          })
          .catch(error => {
            console.log(error)
            reject(error)
            loading.status = false
            commit('SET_LOADING', loading)
          })
      }
    })
  },
  activeTemplate ({ commit, state, getters }, { templateId, active, userEmail }) {
    const loading = {
      name: 'active_template',
      status: true
    }
    return new Promise((resolve, reject) => {
      if (!getters.getLoadingStatusItem(loading.name)) {
        commit('SET_LOADING', loading)
        axios.post(apiUrls.template.activeTemplate(state.accountId, templateId, active, userEmail), withCredentials)
          .then(({ status, statusText, data }) => {
            commit('SET_LOADING', false)
            if (status === 200) {
              resolve({
                success: data
              })
            } else {
              resolve({
                error: {
                  status,
                  statusText
                }
              })
            }
            loading.status = false
            commit('SET_LOADING', loading)
          })
          .catch(error => {
            console.log(error)
            reject(error)
            loading.status = false
            commit('SET_LOADING', loading)
          })
      }
    })
  },
  globalTemplate ({ commit, state, getters }, { templateId, active, userEmail }) {
    const loading = {
      name: 'active_template',
      status: true
    }
    return new Promise((resolve, reject) => {
      if (!getters.getLoadingStatusItem(loading.name)) {
        commit('SET_LOADING', loading)
        axios.post(apiUrls.template.globalTemplates(state.accountId, userEmail), withCredentials)
          .then(({ status, statusText, data }) => {
            commit('SET_LOADING', false)
            if (status === 200) {
              resolve({
                success: data
              })
            } else {
              resolve({
                error: {
                  status,
                  statusText
                }
              })
            }
            loading.status = false
            commit('SET_LOADING', loading)
          })
          .catch(error => {
            console.log(error)
            reject(error)
            loading.status = false
            commit('SET_LOADING', loading)
          })
      }
    })
  },
  setEditorsTypes ({ commit, getters }, { userEmail }) {
    const loading = {
      name: 'set_editor_types',
      status: true
    }
    if (!getters.getLoadingStatusItem(loading.name)) {
      commit('SET_LOADING', loading)
      axios.get(apiUrls.editorsTypes.getEditorsTypes(userEmail), withCredentials)
        .then(response => {
          commit('SET_EDITORS_TYPES', response.data)
          loading.status = false
          commit('SET_LOADING', loading)
        })
        .catch(error => {
          console.log(error)
          loading.status = false
          commit('SET_LOADING', loading)
        })
    }
  },
  setGridStateChangeData ({ commit }, { where }) {
    commit('SET_GRID_STATE_CHANGE_DATA', where)
  },
  setTags ({ commit, getters }, { userEmail }) {
    const loading = {
      name: 'set_tags',
      status: true
    }
    if (!getters.getLoadingStatusItem(loading.name)) {
      commit('SET_LOADING', loading)
      axios.get(apiUrls.template.getTags(userEmail), withCredentials)
        .then(response => {
          commit('SET_TAGS', response.data)
          loading.status = false
          commit('SET_LOADING', loading)
        })
        .catch(error => {
          console.log(error)
          loading.status = false
          commit('SET_LOADING', loading)
        })
    }
  },
  setUsers ({ commit, getters }, { userEmail }) {
    const loading = {
      name: 'set_users',
      status: true
    }
    if (!getters.getLoadingStatusItem(loading.name)) {
      commit('SET_LOADING', loading)
      axios.get(apiUrls.user.getUsers(userEmail), withCredentials)
        .then(response => {
          commit('SET_USERS', response.data)
          loading.status = false
          commit('SET_LOADING', loading)
        })
        .catch(error => {
          console.log(error)
          loading.status = false
          commit('SET_LOADING', loading)
        })
    }
  },
  setEditorPermissions ({ commit, getters }, { externalId, userEmail }) {
    const loading = {
      name: 'set_editor_permissions',
      status: true
    }
    if (!getters.getLoadingStatusItem(loading.name)) {
      commit('SET_LOADING', loading)
      axios.get(apiUrls.editorsTypes.getEditorsPermissions(externalId, userEmail), withCredentials)
        .then(response => {
          const permissionsResponse = response.data
          permissionsResponse.forEach((item) => {
            if (item.settingName === 'HasStudio' && item.settingValue === 'Y') {
              commit('SET_STUDIO_EDITOR_CREATE_PERMISSION', true)
            }
            if (item.settingName === 'HasDragDrop' && item.settingValue === 'Y') {
              commit('SET_DRAG_DROP_CREATE_PERMISSION', true)
            }
            if (item.settingName === 'HasCustomCode' && item.settingValue === 'Y') {
              commit('SET_CUSTOM_CODE_CREATE_PERMISSION', true)
            }
          })
          loading.status = false
          commit('SET_LOADING', loading)
        })
        .catch(error => {
          console.log(error)
          loading.status = false
          commit('SET_LOADING', loading)
        })
    }
  },
  setTemplateOnPreview ({ commit, state, getters }, { userEmail, templateId }) {
    const loading = {
      name: 'set_template_preview',
      status: true
    }
    if (!getters.getLoadingStatusItem(loading.name)) {
      commit('SET_LOADING', loading)
      axios.get(apiUrls.template.getTemplate(state.accountId, userEmail, templateId), withCredentials)
        .then(({ status, data }) => {
          if (status === 200) {
            if (data.version) {
              if (data.version.html.indexOf('dynamiccontent') > -1) {
                const parser = new DOMParser()
                const doc = parser.parseFromString(data.version.html, 'text/html')
                const body = doc.getElementsByTagName('body')[0].innerHTML
                const wrapper = document.createElement('DIV')
                wrapper.innerHTML = body
                const dcs = $(wrapper).find('*[dynamiccontent]')
                if (dcs && dcs.length > 0) {
                  const dcArr = []
                  for (let i = 0; i < dcs.length; i++) {
                    const containerId = $(dcs[i]).attr('dynamiccontent')
                    if (containerId) {
                      dcArr.push(containerId)
                    }
                  }
                  console.log('dcArr: ', dcArr)
                  axios.post(apiUrls.dynamicContent.getDefaultValues(state.accountId, userEmail), dcArr, withCredentials)
                    .then(({ status, statusText, data }) => {
                      if (status === 200) {
                        console.log('data: ', data)
                        data.forEach(item => {
                          const updItem = item.content
                          const isHtml = isHtmlElement(updItem)
                          console.log('isHtml: ', isHtml)
                          if (isHtml) {
                            const $updItem = $(updItem)
                            $updItem.attr('dynamiccontent', item.containerId)
                            $updItem.addClass('dynamiccontent')
                            console.log('to replace: ', $(wrapper).find(`*[dynamiccontent=${item.containerId}]`))
                            console.log('replace with : ', item)
                            $(wrapper).find(`*[dynamiccontent=${item.containerId}]`).replaceWith($updItem.prop('outerHTML'))
                          } else {
                            $(wrapper).find(`*[dynamiccontent=${item.containerId}]`).html(updItem)
                          }
                        })
                        doc.getElementsByTagName('body')[0].innerHTML = $(wrapper).html()
                        const updatedMarkup = '<!DOCTYPE html><html> ' + doc.documentElement.innerHTML + '</html>'
                        commit('SET_TEMPLATE_ON_PREVIEW', updatedMarkup)
                      }
                    })
                    .catch(error => {
                      console.log(error)
                    })
                } else {
                  commit('SET_TEMPLATE_ON_PREVIEW', data.version.html)
                }
              } else {
                commit('SET_TEMPLATE_ON_PREVIEW', data.version.html)
              }
            }
          }
          loading.status = false
          commit('SET_LOADING', loading)
        })
        .catch(error => {
          console.log(error)
          loading.status = false
          commit('SET_LOADING', loading)
        })
    }
  },
  setPrebuiltTemplateOnPreview ({ commit, state, getters }, { userEmail, templateId }) {
    const loading = {
      name: 'set_prebuilt_template_preview',
      status: true
    }
    if (!getters.getLoadingStatusItem(loading.name)) {
      commit('SET_LOADING', loading)
      axios.get(apiUrls.template.getPrebuiltTemplate(state.accountId, userEmail, templateId), withCredentials)
        .then(({ status, data }) => {
          if (status === 200) {
            if (data.version) {
              if (data.version.html.indexOf('dynamiccontent') > -1) {
                const parser = new DOMParser()
                const doc = parser.parseFromString(data.version.html, 'text/html')
                const body = doc.getElementsByTagName('body')[0].innerHTML
                const wrapper = document.createElement('DIV')
                wrapper.innerHTML = body
                const dcs = $(wrapper).find('*[dynamiccontent]')
                if (dcs && dcs.length > 0) {
                  const dcArr = []
                  for (let i = 0; i < dcs.length; i++) {
                    const containerId = $(dcs[i]).attr('dynamiccontent')
                    if (containerId) {
                      dcArr.push(containerId)
                    }
                  }
                  console.log('dcArr: ', dcArr)
                  axios.post(apiUrls.dynamicContent.getDefaultValues(state.accountId, userEmail), dcArr, withCredentials)
                    .then(({ status, statusText, data }) => {
                      if (status === 200) {
                        console.log('data: ', data)
                        data.forEach(item => {
                          const updItem = item.content
                          const isHtml = isHtmlElement(updItem)
                          console.log('isHtml: ', isHtml)
                          if (isHtml) {
                            const $updItem = $(updItem)
                            $updItem.attr('dynamiccontent', item.containerId)
                            $updItem.addClass('dynamiccontent')
                            console.log('to replace: ', $(wrapper).find(`*[dynamiccontent=${item.containerId}]`))
                            console.log('replace with : ', item)
                            $(wrapper).find(`*[dynamiccontent=${item.containerId}]`).replaceWith($updItem.prop('outerHTML'))
                          } else {
                            $(wrapper).find(`*[dynamiccontent=${item.containerId}]`).html(updItem)
                          }
                        })
                        doc.getElementsByTagName('body')[0].innerHTML = $(wrapper).html()
                        const updatedMarkup = '<!DOCTYPE html><html> ' + doc.documentElement.innerHTML + '</html>'
                        commit('SET_TEMPLATE_ON_PREVIEW', updatedMarkup)
                      }
                    })
                    .catch(error => {
                      console.log(error)
                    })
                } else {
                  commit('SET_TEMPLATE_ON_PREVIEW', data.version.html)
                }
              } else {
                commit('SET_TEMPLATE_ON_PREVIEW', data.version.html)
              }
            }
          }
          loading.status = false
          commit('SET_LOADING', loading)
        })
        .catch(error => {
          console.log(error)
          loading.status = false
          commit('SET_LOADING', loading)
        })
    }
  },
  getTagsSections ({ commit, state, getters }, { userEmail }) {
    const loading = {
      name: 'get_tags_sections',
      status: true
    }
    if (!getters.getLoadingStatusItem(loading.name)) {
      commit('SET_LOADING', loading)
      if (state.accountId > 0) {
        const path = apiUrls.dynamicContent.getSections(state.accountId, userEmail)
        return new Promise((resolve, reject) => {
          axios.get(path, withCredentials)
            .then(({ status, statusText, data }) => {
              if (status === 200) {
                commit('SET_TAGS_SECTIONS', data)
                resolve({
                  success: data
                })
              } else {
                resolve({
                  error: true,
                  status,
                  statusText
                })
              }
              loading.status = false
              commit('SET_LOADING', loading)
            })
            .catch(error => {
              console.log(error)
              reject(error)
              loading.status = false
              commit('SET_LOADING', loading)
            })
        })
      }
    }
  },
  getPersonalizationTags ({ commit, state, getters }, { userEmail }) {
    const loading = {
      name: 'get_personalization_tags',
      status: true
    }
    if (!getters.getLoadingStatusItem(loading.name)) {
      commit('SET_LOADING', loading)
      if (state.accountId > 0) {
        const path = apiUrls.dynamicContent.getPersonalizationTags(state.accountId, userEmail)
        return new Promise((resolve, reject) => {
          axios.get(path, withCredentials)
            .then(({ status, statusText, data }) => {
              if (status === 200) {
                const personalizationTags = data.map(tag => {
                  return {
                    ...tag,
                    section: state.dynamicContent.tagsSections.find(section => section.id === tag.sectionID).name
                  }
                })
                commit('SET_PERSONALIZATION_TAGS', personalizationTags)
                resolve({
                  success: data
                })
              } else {
                resolve({
                  error: true,
                  status,
                  statusText
                })
              }
              loading.status = false
              commit('SET_LOADING', loading)
            })
            .catch(error => {
              console.log(error)
              reject(error)
              loading.status = false
              commit('SET_LOADING', loading)
            })
        })
      }
    }
  },
  getBeeFreePersonalizationTags ({ commit, state, getters }, { userEmail }) {
    const loading = {
      name: 'get_personalization_tags',
      status: true
    }
    if (!getters.getLoadingStatusItem(loading.name)) {
      commit('SET_LOADING', loading)
      if (state.accountId > 0) {
        const path = apiUrls.dynamicContent.getPersonalizationTags(state.accountId, userEmail)
        return new Promise((resolve, reject) => {
          axios.get(path, withCredentials)
            .then(({ status, statusText, data }) => {
              if (status === 200) {
                resolve({
                  success: data
                })
              } else {
                resolve({
                  error: true,
                  status,
                  statusText
                })
              }
              loading.status = false
              commit('SET_LOADING', loading)
            })
            .catch(error => {
              console.log(error)
              reject(error)
              loading.status = false
              commit('SET_LOADING', loading)
            })
        })
      }
    }
  },
  getAddOns ({ commit, state, getters }, { clientId, companyId, userEmail }) {
    const loading = {
      name: 'get_add_ons',
      status: true
    }
    if (!getters.getLoadingStatusItem(loading.name)) {
      commit('SET_LOADING', loading)
      return new Promise((resolve, reject) => {
        axios.get(apiUrls.dynamicContent.getAddOns(clientId, companyId, encodeURIComponent(state.einsightUri), userEmail), withCredentials)
          .then(({ status, statusText, data }) => {
            if (status === 200) {
              commit('SET_ADD_ONS', data)
              resolve({
                success: data
              })
            } else {
              resolve({
                error: true,
                status,
                statusText
              })
            }
            loading.status = false
            commit('SET_LOADING', loading)
          })
          .catch(error => {
            console.log(error)
            reject(error)
            loading.status = false
            commit('SET_LOADING', loading)
          })
      })
    }
  },
  getCustomLinks ({ commit, state, getters }, { userEmail }) {
    const loading = {
      name: 'get_custom_links',
      status: true
    }
    if (!getters.getLoadingStatusItem(loading.name)) {
      commit('SET_LOADING', loading)
      return new Promise((resolve, reject) => {
        axios.get(apiUrls.dynamicContent.getCustomLinks(state.accountId, encodeURIComponent(state.customLinksHost), userEmail), withCredentials)
          .then(({ status, statusText, data }) => {
            if (status === 200) {
              commit('SET_CUSTOM_LINKS', data)
              resolve({
                success: data
              })
            } else {
              resolve({
                error: true,
                status,
                statusText
              })
            }
            loading.status = false
            commit('SET_LOADING', loading)
          })
          .catch(error => {
            console.log(error)
            reject(error)
            loading.status = false
            commit('SET_LOADING', loading)
          })
      })
    }
  },
  getGlobalLinks ({ commit, state, getters }, { userEmail }) {
    const loading = {
      name: 'get_global_links',
      status: true
    }
    if (!getters.getLoadingStatusItem(loading.name)) {
      commit('SET_LOADING', loading)
      return new Promise((resolve, reject) => {
        axios.get(apiUrls.dynamicContent.getGlobalLinks(state.accountId, userEmail), withCredentials)
          .then(({ status, statusText, data }) => {
            if (status === 200) {
              commit('SET_GLOBAL_LINKS', data)
              resolve({
                success: data
              })
            } else {
              resolve({
                error: true,
                status,
                statusText
              })
            }
            loading.status = false
            commit('SET_LOADING', loading)
          })
          .catch(error => {
            console.log(error)
            reject(error)
            loading.status = false
            commit('SET_LOADING', loading)
          })
      })
    }
  },
  addGlobalLink ({ commit, state, getters }, { userEmail, data }) {
    const loading = {
      name: 'add_global_links',
      status: true
    }
    if (!getters.getLoadingStatusItem(loading.name)) {
      commit('SET_LOADING', loading)
      return new Promise((resolve, reject) => {
        axios.post(apiUrls.dynamicContent.addGlobalLink(state.accountId, userEmail), data, withCredentials)
          .then(({ status, statusText, data }) => {
            if (status === 200) {
              resolve({
                success: data
              })
            } else {
              resolve({
                error: true,
                status,
                statusText
              })
            }
            loading.status = false
            commit('SET_LOADING', loading)
          })
          .catch(error => {
            console.log(error)
            reject(error)
            loading.status = false
            commit('SET_LOADING', loading)
          })
      })
    }
  },
  updateGlobalLink ({ commit, state, getters }, { linkId, userEmail, data }) {
    const loading = {
      name: 'update_global_link',
      status: true
    }
    if (!getters.getLoadingStatusItem(loading.name)) {
      commit('SET_LOADING', loading)
      return new Promise((resolve, reject) => {
        axios.post(apiUrls.dynamicContent.updateGlobalLink(state.accountId, linkId, userEmail), data, withCredentials)
          .then(({ status, statusText, data }) => {
            if (status === 200) {
              resolve({
                success: data
              })
            } else {
              resolve({
                error: true,
                status,
                statusText
              })
            }
            loading.status = false
            commit('SET_LOADING', loading)
          })
          .catch(error => {
            console.log(error)
            reject(error)
            loading.status = false
            commit('SET_LOADING', loading)
          })
      })
    }
  },
  deleteGlobalLink ({ commit, state, getters }, { linkId, userEmail }) {
    const loading = {
      name: 'delete_global_link',
      status: true
    }
    if (!getters.getLoadingStatusItem(loading.name)) {
      commit('SET_LOADING', loading)
      return new Promise((resolve, reject) => {
        axios.post(apiUrls.dynamicContent.deleteGlobalLink(state.accountId, linkId, userEmail), withCredentials)
          .then(({ status, statusText, data }) => {
            if (status === 200) {
              resolve({
                success: data
              })
            } else {
              resolve({
                error: true,
                status,
                statusText
              })
            }
            loading.status = false
            commit('SET_LOADING', loading)
          })
          .catch(error => {
            console.log(error)
            reject(error)
            loading.status = false
            commit('SET_LOADING', loading)
          })
      })
    }
  },
  getTaggedLinks ({ commit, state, getters }, { templateId, userEmail }) {
    const loading = {
      name: 'get_tagged_links',
      status: true
    }
    if (!getters.getLoadingStatusItem(loading.name)) {
      commit('SET_LOADING', loading)
      return new Promise((resolve, reject) => {
        axios.get(apiUrls.dynamicContent.getTaggedLinks(state.accountId, templateId, userEmail), withCredentials)
          .then(({ status, statusText, data }) => {
            if (status === 200) {
              const taggedLinks = data.map(item => ({ value: item }))

              commit('SET_TAGGED_LINKS', taggedLinks)
              resolve({
                success: taggedLinks
              })
            } else {
              resolve({
                error: true,
                status,
                statusText
              })
            }
            loading.status = false
            commit('SET_LOADING', loading)
          })
          .catch(error => {
            console.log(error)
            reject(error)
            loading.status = false
            commit('SET_LOADING', loading)
          })
      })
    }
  },
  getSystemLinks ({ commit, state, getters }, { templateId, userEmail }) {
    const loading = {
      name: 'get_system_links',
      status: true
    }
    if (!getters.getLoadingStatusItem(loading.name)) {
      commit('SET_LOADING', loading)
      return new Promise((resolve, reject) => {
        axios.get(apiUrls.dynamicContent.getSystemLinks(state.accountId, templateId, userEmail), withCredentials)
          .then(({ status, statusText, data }) => {
            if (status === 200) {
              const systemLinks = data.map(item => ({ value: item }))

              commit('SET_SYSTEM_LINKS', systemLinks)
              resolve({
                success: systemLinks
              })
            } else {
              resolve({
                error: true,
                status,
                statusText
              })
            }
            loading.status = false
            commit('SET_LOADING', loading)
          })
          .catch(error => {
            console.log(error)
            reject(error)
            loading.status = false
            commit('SET_LOADING', loading)
          })
      })
    }
  },
  getAllLinks ({ commit, state, getters }, { templateId, userEmail }) {
    const loading = {
      name: 'get_all_links',
      status: true
    }
    if (!getters.getLoadingStatusItem(loading.name)) {
      commit('SET_LOADING', loading)
      return new Promise((resolve, reject) => {
        axios.get(apiUrls.dynamicContent.getAllLinks(state.accountId, templateId, userEmail), withCredentials)
          .then(({ status, statusText, data }) => {
            if (status === 200) {
              const allLinks = []

              data.forEach((item, index) => {
                allLinks.push({
                  index: index + 1,
                  type: 'cols',
                  value: item
                })
                allLinks.push({
                  index: 0,
                  type: 'textarea',
                  value: item
                })
              })

              commit('SET_ALL_LINKS', allLinks)
              resolve({
                success: allLinks
              })
            } else {
              resolve({
                error: true,
                status,
                statusText
              })
            }
            loading.status = false
            commit('SET_LOADING', loading)
          })
          .catch(error => {
            console.log(error)
            reject(error)
            loading.status = false
            commit('SET_LOADING', loading)
          })
      })
    }
  },
  sendTest ({ commit, state, getters }, { templateId, userEmail, data }) {
    const loading = {
      name: 'send_test',
      status: true
    }
    if (!getters.getLoadingStatusItem(loading.name)) {
      commit('SET_LOADING', loading)
      return new Promise((resolve, reject) => {
        axios.post(apiUrls.template.sendTest(state.accountId, templateId, userEmail), data, withCredentials)
          .then(({ status, statusText, data }) => {
            if (status === 200 && data) {
              resolve({
                success: true
              })
            } else {
              resolve({
                error: true,
                status,
                statusText
              })
            }
            loading.status = false
            commit('SET_LOADING', loading)
          })
          .catch(error => {
            console.log(error)
            reject(error)
            loading.status = false
            commit('SET_LOADING', loading)
          })
      })
    }
  },
  getSeedList ({ commit, state, getters }, { userEmail }) {
    const loading = {
      name: 'get_seed_list',
      status: true
    }
    if (!getters.getLoadingStatusItem(loading.name)) {
      commit('SET_LOADING', loading)
      return new Promise((resolve, reject) => {
        axios.get(apiUrls.template.getSeedList(state.accountId, userEmail), withCredentials)
          .then(({ status, statusText, data }) => {
            if (status === 200) {
              const { recipients, canModifyTestList, canModifyGlobalList } = data
              const groups = {
                EmailToSelf: true,
                Test: true,
                Global: true,
                Group: true
              }
              const seedList = []

              // EMAIL TO SELF - STARTS
              seedList.push({
                id: 'EmailToSelf',
                pid: null,
                name: 'Email to self',
                hasChild: true,
                expanded: true
              })
              seedList.push({
                id: userEmail,
                pid: 'EmailToSelf',
                name: userEmail,
                isChecked: 'true'
              })
              // EMAIL TO SELF - ENDS

              seedList.push({
                id: 'Test',
                pid: null,
                name: 'Test Seed List',
                hasChild: true,
                expanded: true
              })

              seedList.push({
                id: 'Global',
                pid: null,
                name: 'Global Seed List',
                hasChild: true,
                expanded: true
              })

              seedList.push({
                id: 'Group',
                pid: null,
                name: 'Group Seed List',
                hasChild: true,
                expanded: true
              })

              recipients.forEach(item => {
                const completeName = item.firstName + ' ' + item.lastName
                if (item.seedListType.toLowerCase() === 'group') {
                  const _seedListType = item.listTitle.replace(' ', '_')
                  if (!Object.prototype.hasOwnProperty.call(groups, _seedListType)) {
                    groups[_seedListType] = true
                    seedList.push({
                      id: _seedListType,
                      pid: 'Group',
                      name: item.listTitle,
                      hasChild: true,
                      expanded: false
                    })
                  }
                  seedList.push({
                    ...item,
                    beid: item.id,
                    id: '[' + _seedListType + ']' + item.email,
                    pid: _seedListType,
                    name: (completeName.trim().length ? completeName + ', ' : '') + item.email
                  })
                } else {
                  if (!Object.prototype.hasOwnProperty.call(groups, item.seedListType)) {
                    groups[item.seedListType] = true
                    seedList.push({
                      id: item.seedListType,
                      pid: null,
                      name: item.listTitle,
                      hasChild: true,
                      expanded: true
                    })
                  }
                  seedList.push({
                    ...item,
                    beid: item.id,
                    id: '[' + item.seedListType + ']' + item.email,
                    pid: item.seedListType,
                    name: (completeName.trim().length ? completeName + ', ' : '') + item.email
                  })
                }
              })

              const emailTesting = {
                groups,
                canModifyTestList,
                canModifyGlobalList,
                emailList: seedList
              }

              commit('SET_EMAIL_TESTING', emailTesting)
              resolve({
                success: emailTesting
              })
            } else {
              resolve({
                error: true,
                status,
                statusText
              })
            }
            loading.status = false
            commit('SET_LOADING', loading)
          })
          .catch(error => {
            console.log(error)
            reject(error)
            loading.status = false
            commit('SET_LOADING', loading)
          })
      })
    }
  },
  addSeedListRecipient ({ commit, state, getters }, { data, userEmail }) {
    const loading = {
      name: 'add_seed_list_recipient',
      status: true
    }
    if (!getters.getLoadingStatusItem(loading.name)) {
      commit('SET_LOADING', loading)
      return new Promise((resolve, reject) => {
        axios.post(apiUrls.template.addSeedListRecipient(state.accountId, userEmail), data, withCredentials)
          .then(({ status, statusText, data }) => {
            if (status === 200) {
              resolve(data)
            } else {
              resolve({
                error: true,
                status,
                statusText
              })
            }
            loading.status = false
            commit('SET_LOADING', loading)
          })
          .catch(error => {
            console.log(error)
            reject(error)
            loading.status = false
            commit('SET_LOADING', loading)
          })
      })
    }
  },
  deleteSeedListRecipient ({ commit, state, getters }, { recipientId, listType, userEmail }) {
    const loading = {
      name: 'delete_seed_list_recipient',
      status: true
    }
    if (!getters.getLoadingStatusItem(loading.name)) {
      commit('SET_LOADING', loading)
      return new Promise((resolve, reject) => {
        axios.post(apiUrls.template.deleteSeedListRecipient(state.accountId, recipientId, listType, userEmail), withCredentials)
          .then(({ status, statusText, data }) => {
            if (status === 200) {
              resolve({
                success: true
              })
            } else {
              resolve({
                error: true,
                status,
                statusText
              })
            }
            loading.status = false
            commit('SET_LOADING', loading)
          })
          .catch(error => {
            console.log(error)
            reject(error)
            loading.status = false
            commit('SET_LOADING', loading)
          })
      })
    }
  },
  updateSeedListRecipient ({ commit, state, getters }, { recipientId, data, userEmail }) {
    const loading = {
      name: 'update_seed_list_recipient',
      status: true
    }
    if (!getters.getLoadingStatusItem(loading.name)) {
      commit('SET_LOADING', loading)
      return new Promise((resolve, reject) => {
        axios.post(apiUrls.template.updateSeedListRecipient(state.accountId, recipientId, userEmail), data, withCredentials)
          .then(({ status, statusText, data }) => {
            if (status === 200) {
              resolve(data)
            } else {
              resolve({
                error: true,
                status,
                statusText
              })
            }
            loading.status = false
            commit('SET_LOADING', loading)
          })
          .catch(error => {
            console.log(error)
            reject(error)
            loading.status = false
            commit('SET_LOADING', loading)
          })
      })
    }
  }
}
